COMMON.Browser = function($) {

  var userAgent = function userAgent() {
    var browserCheck, userAgent = navigator.userAgent;

    if (userAgent.indexOf("Firefox") > -1) {
      browserCheck = "mozillaFirefox";
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
      browserCheck = "opera";
    } else if (userAgent.indexOf("Trident") > -1) {
      browserCheck = "microsoftExplorer";
    } else if (userAgent.indexOf("Edge") > -1) {
      browserCheck = "microsoftEdge";
    } else if (userAgent.indexOf("Chrome") > -1) {
      browserCheck = "googleChrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserCheck = "appleSafari";
    } else {
      browserCheck = "unknown";
    }

    return browserCheck;
  };

  var runningOnBrowser = typeof window !== "undefined";

  return {
    mobile: navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ? !0 : !1,

    userAgent: userAgent(),

    isBot: (runningOnBrowser && !("onscroll" in window)) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)
  };

}(window.jQuery);
